import { PLAN_ANNUAL, PLAN_MONTHLY } from '../../Constants/plans'

export const TIER_ESSENTIALS = 'essentials'
export const TIER_PREMIUM = 'premium'

export const toUpgradePlan = (tier, term) => `${tier}_${term}`

export const UPGRADE_PLANS = Object.freeze({
  ESSENTIALS_MONTHLY: toUpgradePlan(TIER_ESSENTIALS, PLAN_MONTHLY),
  ESSENTIALS_ANNUAL: toUpgradePlan(TIER_ESSENTIALS, PLAN_ANNUAL),
  PREMIUM_MONTHLY: toUpgradePlan(TIER_PREMIUM, PLAN_MONTHLY),
  PREMIUM_ANNUAL: toUpgradePlan(TIER_PREMIUM, PLAN_ANNUAL),
})
